export function addressBookSetAddressesForPostCode({ state, action }) {
  return {
    ...state,
    addAddress: {
      ...state.addAddress,
      addresses: action.addresses,
      canDeliver: action.canDeliver,
      city: action.city,
      deliveryAreaType: action.deliveryAreaType,
      postcode: action.postcode,
    },
  };
}

export function addressBookResetAddAddressForm({ state }) {
  return {
    ...state,
    addAddress: {
      ...state.addAddress,
      addresses: [],
      city: '',
      postcodeErrorCode: '',
      manualAddressError: '',
      cityError: '',
      selectedAddressId: '',
      addressNickname: '',
      manualAddressLine: '',
      deliveryInstructions: '',
      typeAddressManually: false,
      canDeliver: false,
      deliveryAreaType: '',
    },
  };
}

export function addressBookSetPostcodeErrorCode({ state, action }) {
  return {
    ...state,
    addAddress: {
      ...state.addAddress,
      postcodeErrorCode: action.postcodeErrorCode,
    },
  };
}

export function addressBookSetManualAddressError({ state, action }) {
  return {
    ...state,
    addAddress: {
      ...state.addAddress,
      manualAddressError: action.manualAddressError,
    },
  };
}

export function addressBookSetCityError({ state, action }) {
  return {
    ...state,
    addAddress: {
      ...state.addAddress,
      cityError: action.cityError,
    },
  };
}

export function addressBookToggleManualAddressEntering({ state }) {
  return { ...state, addAddress: { ...state.addAddress, typeAddressManually: true } };
}

export function addressBookUpdateField({ state, action }) {
  return { ...state, addAddress: { ...state.addAddress, [action.field]: action.value } };
}

export function addressBookSetDeliveryAddressToEdit({ state, action }) {
  return { ...state, addressToEdit: action.address };
}
